export default __webpack_public_path__ + "static/media/openflagimage.9c95e3e1.png";